import type { ForecastMonthAmount, ForecastMonthMetric } from '@/api/types'
import { monthMetricAmount } from '@/lib/month-strip'

export type ForecastQuarter = 'all' | 1 | 2 | 3 | 4

export const QUARTER_OPTIONS: Array<{ value: ForecastQuarter; label: string }> = [
  { value: 'all', label: 'Full year' },
  { value: 1, label: 'Q1' },
  { value: 2, label: 'Q2' },
  { value: 3, label: 'Q3' },
  { value: 4, label: 'Q4' },
]

/** Calendar months (1–12) included in a quarter filter. */
export function monthsForQuarter(quarter: ForecastQuarter): number[] {
  if (quarter === 'all') return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  const start = (quarter - 1) * 3 + 1
  return [start, start + 1, start + 2]
}

export function parseQuarterParam(raw: string | null): ForecastQuarter {
  if (raw === '1' || raw === '2' || raw === '3' || raw === '4') {
    return Number(raw) as 1 | 2 | 3 | 4
  }
  return 'all'
}

/** Sum metric amounts for months in the selected quarter. */
export function sumMetricForQuarter(
  months: ForecastMonthAmount[] | undefined,
  metric: ForecastMonthMetric,
  quarter: ForecastQuarter,
): number {
  const allowed = new Set(monthsForQuarter(quarter))
  const byMonth = new Map((months ?? []).map((row) => [row.month, row]))
  let total = 0
  for (const month of allowed) {
    total += monthMetricAmount(byMonth.get(month), metric)
  }
  return total
}

/** Keep only quarter months for month-strip display (ordered). */
export function filterAmountsForQuarter(amounts: number[], quarter: ForecastQuarter): number[] {
  if (quarter === 'all') return amounts
  const allowed = monthsForQuarter(quarter)
  return allowed.map((month) => amounts[month - 1] ?? 0)
}

export function quarterMonthLabels(quarter: ForecastQuarter): string[] {
  const labels = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return monthsForQuarter(quarter).map((month) => labels[month - 1] ?? '')
}
